import { render, staticRenderFns } from "./SamplesUpdateUtil.vue?vue&type=template&id=2f6a71c8&"
import script from "./SamplesUpdateUtil.vue?vue&type=script&lang=js&"
export * from "./SamplesUpdateUtil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports